<template>
  <div>
    <i class="fa fa-check text-success"></i>
    Per commercial stellen we standaard {{ITEMS.length}} vragen
    <v-button
      style-type="secondary"
      size="xs"
      :text="`word.${showItems ? 'hide' : 'show'}`"
      :rounded="true"
      @click="showItems = !showItems"
    />
    <v-collapse-transition>
      <div class="mt-2 p-0 card bg-dark text-white" v-if="showItems">
        <ul class="m-4">
          <li
            v-for="(item, index) in ITEMS"
            :key="index"
          >
            <small>{{ item }}</small>
          </li>
        </ul>
      </div>
    </v-collapse-transition>
  </div>
</template>

<script>
import Button from '@/common/components/Button.vue';
import { CollapseTransition } from '@ivanv/vue-collapse-transition';

const ITEMS = [
  'Wat zijn je eerste gedachten over deze commercial?',
  'Heb je deze commercial al eerder gezien?',
  'In hoeverre vind je deze commercial leuk om naar te kijken?',
  'In hoeverre vind je deze commercial irritant?',
  'In hoeverre vind je deze commercial geloofwaardig?',
  'In hoeverre vind je deze commercial onderscheidend?',
  'In hoeverre zet de commercial je aan tot actie?',
  'Welk cijfer geef je deze commercial?',
];


export default {
  name: 'CommercialQuestions',
  components: {
    'v-button': Button,
    'v-collapse-transition': CollapseTransition,
  },
  props: {
    commercialType: {
      type: String,
      required: true,
    },
    researchType: {
      type: String,
      required: true,
    },
  },
  computed: {
    commercialDefinition() {
      if (this.commercialType === 'ooh') {
        return 'buitenreclame';
      }
      return 'commercial';
    },
  },
  data() {
    return {
      ITEMS,
      showItems: false,
    };
  },
};
</script>
